function getProjectPageRoute(projectId) {
  return `/projects/${projectId}/`;
}

module.exports = {
  getProjectPageRoute,
};



// WEBPACK FOOTER //
// ./src/utils/routing.js